module.exports = __webpack_public_path__ + "img/ico_tab5_moreactive@2x.fefa745a.png";